import * as React from 'react';

import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';

import { FormattedMessage, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';

import { LayoutHeader } from 'components/Layout';
import { ROUTE_STATIC_CONTACT_US } from 'constants/app';
import { AppState } from 'models/app';

import './AccountPhoneDetail.scss';

interface StateProps {
  phone: string;
}

type OwnProps = InjectedIntlProps & RouteComponentProps<{}>;
type AccountPhoneDetailProps = OwnProps & StateProps;

class AccountPhoneDetailContainer extends React.Component<AccountPhoneDetailProps, {}> {
  render() {
    const { history, phone } = this.props;

    return (
      <div className="o-container o-container--fluid o-container--fluid-vertical">
        <LayoutHeader actionIcon="ic-arrow-left" actionHandler={history.goBack}>
          <h1 className="o-layout-header-title">
            <FormattedMessage id="account.profile.phonenumber"/>
          </h1>
        </LayoutHeader>

        <div className="account-phone-detail__phone-container">
          <div className="account-phone-detail__phone-label o-footnote-1">
            <FormattedMessage id="account.profile.phonenumber"/>
          </div>
          <div className="account-phone-detail__phone-value">
            {phone}
          </div>
        </div>

        <div className="account-phone-detail__message">
          <FormattedMessage id="account.profile.phonenumber.change.message"/>
          <Link to={ROUTE_STATIC_CONTACT_US}>
            <FormattedMessage id="account.profile.phonenumber.change.contact.us"/>
          </Link>
        </div>
      </div>
    );
  }
}

export const AccountPhoneDetail = connect<StateProps, {}, OwnProps>(
  (state: AppState) => ({
    phone: state.accountState.account.phone
  }), {}
)(AccountPhoneDetailContainer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Account/Phone/AccountPhoneDetail/AccountPhoneDetail.tsx